module.exports = __webpack_public_path__ + "static/media/Diana.cf56348c.png";